export default __webpack_public_path__ + "static/media/icn_light.ca985f2f.svg";